export const ROLE_MAP = {
  partneradmin: 'admin',
  partneragent: 'agent',
}

export const getRole = (role) => ROLE_MAP[role] || 'user'

export default null
